define(["dojo/i18n", "/local/buildagent/work/bab00163f105c0e5/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"dijit/form/nls/bs/validate"
,"dijit/form/nls/mk/validate"
,"dijit/form/nls/sr/validate"
,"dijit/form/nls/zh/validate"
,"dijit/form/nls/zh-tw/validate"
,"dijit/form/nls/uk/validate"
,"dijit/form/nls/tr/validate"
,"dijit/form/nls/th/validate"
,"dijit/form/nls/sv/validate"
,"dijit/form/nls/sl/validate"
,"dijit/form/nls/sk/validate"
,"dijit/form/nls/ru/validate"
,"dijit/form/nls/ro/validate"
,"dijit/form/nls/pt/validate"
,"dijit/form/nls/pt-pt/validate"
,"dijit/form/nls/pl/validate"
,"dijit/form/nls/nl/validate"
,"dijit/form/nls/nb/validate"
,"dijit/form/nls/ko/validate"
,"dijit/form/nls/kk/validate"
,"dijit/form/nls/ja/validate"
,"dijit/form/nls/it/validate"
,"dijit/form/nls/id/validate"
,"dijit/form/nls/hu/validate"
,"dijit/form/nls/hr/validate"
,"dijit/form/nls/he/validate"
,"dijit/form/nls/fr/validate"
,"dijit/form/nls/fi/validate"
,"dijit/form/nls/eu/validate"
,"dijit/form/nls/es/validate"
,"dijit/form/nls/el/validate"
,"dijit/form/nls/de/validate"
,"dijit/form/nls/da/validate"
,"dijit/form/nls/cs/validate"
,"dijit/form/nls/ca/validate"
,"dijit/form/nls/bg/validate"
,"dijit/form/nls/az/validate"
,"dijit/form/nls/ar/validate"
,"dijit/form/nls/al/validate"
,"/local/buildagent/work/bab00163f105c0e5/target/debug/2P/derived/ui/dijit/form/nls/validate.js?absMid=dijit/form/nls/validate"
], function(loader, runner) {
   return runner(loader, "dijit/form/nls/validate", __webpack_require__.dj.c(), true);
});